export const quickNews = [
  "网传某顶流男演员深夜被拍同框神秘女子，双方均未回应",
  "千万粉丝美妆博主被指带货翻车，品牌方称正核实售后记录",
  "王牌综艺录制现场传不和，节目组回应「录制顺利」",
  "古装大剧临开机换角，网传原定女主因档期退出",
  "电竞主播与搭档官宣分手，后援会宣布暂停集贤活动",
  "某歌手代言解约传闻发酵，工作室称合约仍在正常履行",
  "某短剧男配被曝私下加价，制片方称「以正式合同为准」",
  "网红餐厅被质疑食材来源，市场监管部门已介入了解",
];

export const timeline = [
  {
    id: "tl-1",
    date: "10-10",
    time: "22:41",
    category: "明星",
    title: "深夜同框视频流出",
    desc: "有网友晒出一段商场外夜景视频，称拍到某男演员与一女子同行。视频为远景模糊拍摄，未出现正面画面，双方工作室截至发稿暂无回应。",
  },
  {
    id: "tl-2",
    date: "10-10",
    time: "20:15",
    category: "网红",
    title: "带货翻车售后争议持续",
    desc: "多位消费者在社交平台反映某美妆博主直播间商品与描述不符。博主方回应称已开启专属售后通道，品牌方表示正在核对订单批次。",
  },
  {
    id: "tl-3",
    date: "10-10",
    time: "17:02",
    category: "综艺",
    title: "录制现场不和传闻",
    desc: "一条「现场起争执」的帖子在多个吃瓜小组流传，配图为空镜。节目组官方账号回应「录制顺利，请勿过度解读」。",
  },
  {
    id: "tl-4",
    date: "10-10",
    time: "14:36",
    category: "影视",
    title: "古装剧换角风波",
    desc: "网传某古装大剧女主换人，原因指向档期冲突。剧方未发布正式公告，立项信息目前仍显示原阵容。",
  },
  {
    id: "tl-5",
    date: "10-10",
    time: "11:20",
    category: "品牌",
    title: "代言解约传闻",
    desc: "有营销号称某歌手与品牌方提前解约。品牌官方渠道的代言物料仍可正常查看，工作室回复称「合约正常履行中」。",
  },
  {
    id: "tl-6",
    date: "10-09",
    time: "23:48",
    category: "网红",
    title: "情侣主播官宣分手",
    desc: "两位电竞主播先后发文确认结束合作关系，粉丝后援会宣布暂停活动。双方均表示「规划不同，好聚好散」。",
  },
  {
    id: "tl-7",
    date: "10-09",
    time: "19:07",
    category: "争议",
    title: "短剧配角被曝临时加价",
    desc: "有剧组工作人员在论坛发帖称某配角临场加价，导致拍摄延期。制片方回应「一切以正式合同条款为准」。",
  },
  {
    id: "tl-8",
    date: "10-09",
    time: "15:33",
    category: "网红",
    title: "网红餐厅食材来源受质疑",
    desc: "有探店视频指出某网红餐厅食材标注与实际不符，市场监管部门表示已就相关线索进行了解。",
  },
  {
    id: "tl-9",
    date: "10-09",
    time: "10:12",
    category: "明星",
    title: "旧照考古引发热议",
    desc: "一组早年活动旧照被翻出，网友围绕造型与场合展开讨论。相关内容为公开活动照片，无新增事实性信息。",
  },
  {
    id: "tl-10",
    date: "10-08",
    time: "21:50",
    category: "影视",
    title: "片场路透引发造型讨论",
    desc: "剧组外景路透图流传，网友对角色造型评价两极。剧方未就造型设计作出说明。",
  },
];

export const exposeItems = [
  {
    id: "ex-1",
    title: "顶流男演员深夜同框神秘女子，疑似新恋情",
    summary: "网传一段远景夜景视频显示某男演员与一女子同行。画面模糊、无正面镜头，双方均未回应，真实性有待确认。",
    category: "恋情",
    tags: ["明星", "恋情"],
    heat: 98,
    time: "22 分钟前",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20blurry%20night%20street%20scene%20with%20warm%20amber%20street%20lamps%20and%20soft%20camera%20flash%20glow%2C%20abstract%20no%20identifiable%20faces%2C%20moody%20red%20and%20gold%20tones%2C%20editorial%20photography%2C%20shallow%20depth%20of%20field&width=800&height=520&seq=expose-night-01&orientation=landscape",
    source: "网友投稿 · 待核实",
  },
  {
    id: "ex-2",
    title: "千万粉丝美妆博主被指带货翻车，售后争议发酵",
    summary: "多位消费者反映直播间商品与描述不符。博主方已开通专属售后通道，品牌方称正在核对订单批次，事件仍在处理中。",
    category: "争议",
    tags: ["网红", "售后"],
    heat: 94,
    time: "1 小时前",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20softly%20lit%20studio%20vanity%20table%20with%20cosmetics%20bottles%20in%20warm%20pink%20and%20gold%20tone%2C%20shallow%20depth%20of%20field%2C%20no%20people%2C%20editorial%20product%20photography%2C%20clean%20background&width=800&height=520&seq=expose-beauty-02&orientation=landscape",
    source: "平台投诉整理",
  },
  {
    id: "ex-3",
    title: "王牌综艺录制现场传争执，节目组回应录制顺利",
    summary: "多条「现场起争执」帖子在吃瓜小组流传，配图均为空镜。节目组官方账号回应称录制正常进行，请勿过度解读。",
    category: "综艺",
    tags: ["综艺", "传闻"],
    heat: 88,
    time: "2 小时前",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20blurred%20television%20studio%20with%20warm%20red%20spotlights%20and%20empty%20stage%20seats%2C%20no%20people%2C%20cinematic%20bokeh%2C%20warm%20amber%20tones%2C%20editorial%20photography&width=800&height=520&seq=expose-variety-03&orientation=landscape",
    source: "小组传闻 · 双方口径不一致",
  },
  {
    id: "ex-4",
    title: "古装大剧临开机换角，网传原定女主因档期退出",
    summary: "有营销号称某古装剧女主换人，原因指向档期冲突。剧方尚未发布正式公告，公开立项信息仍显示原阵容。",
    category: "影视",
    tags: ["影视", "换角"],
    heat: 83,
    time: "3 小时前",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20traditional%20Chinese%20courtyard%20lantern%20glow%20with%20red%20silk%20drapery%2C%20blurred%20and%20atmospheric%2C%20no%20people%2C%20warm%20crimson%20and%20gold%20tones%2C%20cinematic%20editorial%20photography&width=800&height=520&seq=expose-costume-04&orientation=landscape",
    source: "营销号爆料 · 未官宣",
  },
  {
    id: "ex-5",
    title: "电竞主播与搭档官宣分手，后援会宣布暂停集贤",
    summary: "两位电竞主播先后发文确认结束合作，表示「规划不同，好聚好散」。粉丝后援会发布公告暂停集贤与打榜活动。",
    category: "网红",
    tags: ["网红", "主播"],
    heat: 79,
    time: "4 小时前",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20dark%20gaming%20setup%20with%20warm%20red%20and%20amber%20RGB%20light%20stripes%20and%20blurred%20screens%2C%20no%20people%2C%20cinematic%20bokeh%2C%20editorial%20photography&width=800&height=520&seq=expose-esports-05&orientation=landscape",
    source: "当事人公开声明",
  },
  {
    id: "ex-6",
    title: "某歌手与品牌解约传闻，工作室称合约正常履行",
    summary: "有账号称某歌手与品牌方提前解约。品牌官方渠道代言物料仍可正常查看，工作室回复称合约正常履行中，未见正式公告。",
    category: "品牌",
    tags: ["明星", "品牌"],
    heat: 76,
    time: "5 小时前",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20luxury%20brand%20display%20wall%20with%20warm%20gold%20lighting%20and%20blurred%20elegant%20boutique%20interior%2C%20no%20people%2C%20cinematic%20soft%20focus%2C%20editorial%20photography&width=800&height=520&seq=expose-brand-06&orientation=landscape",
    source: "网传 · 已获工作室回应",
  },
  {
    id: "ex-7",
    title: "短剧男配被曝临场加价，制片方称以合同为准",
    summary: "有剧组工作人员在论坛发帖称某配角临场加价导致延期。制片方回应「一切以正式合同条款为准」，未公布进一步处理结果。",
    category: "争议",
    tags: ["影视", "片酬"],
    heat: 71,
    time: "6 小时前",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20film%20set%20with%20warm%20amber%20key%20light%20and%20blurred%20camera%20equipment%20silhouettes%2C%20no%20people%2C%20cinematic%20bokeh%2C%20warm%20red%20tones%2C%20editorial%20photography&width=800&height=520&seq=expose-drama-07&orientation=landscape",
    source: "论坛爆料",
  },
  {
    id: "ex-8",
    title: "网红餐厅食材来源受质疑，市场监管介入了解",
    summary: "一条探店视频指出某网红餐厅食材标注与实际不符。市场监管部门表示已就相关线索进行了解，结果以官方通报为准。",
    category: "网红",
    tags: ["网红", "消费"],
    heat: 68,
    time: "8 小时前",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20cozy%20modern%20restaurant%20interior%20with%20warm%20hanging%20lights%20and%20blurred%20wood%20tables%2C%20no%20people%2C%20cinematic%20bokeh%2C%20amber%20and%20rose%20tones%2C%20editorial%20photography&width=800&height=520&seq=expose-restaurant-08&orientation=landscape",
    source: "探店视频引发",
  },
];

export const hotList = [
  { rank: 1, title: "顶流男演员深夜同框神秘女子", category: "恋情", heat: 98, trend: "new" },
  { rank: 2, title: "美妆博主带货翻车售后争议", category: "争议", heat: 94, trend: "up" },
  { rank: 3, title: "王牌综艺录制现场争执传闻", category: "综艺", heat: 88, trend: "up" },
  { rank: 4, title: "古装大剧临开机换角风波", category: "影视", heat: 83, trend: "down" },
  { rank: 5, title: "电竞主播与搭档官宣分手", category: "网红", heat: 79, trend: "up" },
  { rank: 6, title: "某歌手品牌解约传闻", category: "品牌", heat: 76, trend: "new" },
  { rank: 7, title: "短剧男配临场加价被曝", category: "争议", heat: 71, trend: "down" },
  { rank: 8, title: "网红餐厅食材来源受质疑", category: "网红", heat: 68, trend: "up" },
  { rank: 9, title: "旧照考古造型讨论", category: "明星", heat: 63, trend: "down" },
  { rank: 10, title: "剧组路透造型评价两极", category: "影视", heat: 59, trend: "new" },
];